module.exports = __webpack_public_path__ + "02_mid_yellow.1ae66080.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_mid_yellow.png
// module id = BJgN
// module chunks = 0